'use strict';

function _interopDefault (ex) { return (ex && (typeof ex === 'object') && 'default' in ex) ? ex['default'] : ex; }

var React = require('react');
var React__default = _interopDefault(React);
var NotificationProvider = require('../NotificationHandlerProvider/NotificationProvider.js');

function useNotification() {
    var _a = React.useContext(NotificationProvider.NotificationContext), notification = _a.notification, addNotification = _a.addNotification, removeNotification = _a.removeNotification;
    return { notification: notification, addNotification: addNotification, removeNotification: removeNotification };
}

module.exports = useNotification;
